import { Provider } from 'react-redux';
import './App.css';
import store from './redux/store';
import AppRouter from './routers/AppRouter';
import { ToastProvider } from './components/toast/ToastProvider';

const App = () => {
  return (
    <Provider store={store} >
      <ToastProvider>
        <AppRouter />
      </ToastProvider>
    </Provider>
  );
}

export default App;
